/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import MaterialLibrary from "App/geometry/material/material_library";
import RenderDocument from "App/render_document_interface";
import {mat4} from "gl-matrix";
import GeometryDescription from "App/geometry/description";
import ModelDescription from "App/model/description";
import BoundingBox from "App/utils/bounding_box";
import {RenderElement} from "App/model/elements/element";
import ZeropointSettings from "App/model/zeropoint_settings";
import {ConfigurationData} from "App/model/configuration";
import {LightingSettingsData} from "App/model/lighting_settings";
import GroupTree from "App/model/group_tree";
import Messenger from "App/messenger";
import {logError} from "App/debug";
import RenderObject from "App/geometry/objects/object";
import ProgressDispatchHelper from "App/utils/progress_dispatch_helper";
import {UPDATETYPES} from "App/render/webgl/renderables/batches/batch";
import {inURLBinaryData} from "App/storage/utils";
import IModel from "js_interface/src/structural_elements/model_interface";
import IScene from "js_interface/src/scene_interface";
import Model from "App/model";

export default
class Asset extends Model {

    private transformation: mat4 = mat4.create();

    // tslint:disable-next-line:max-line-length
    constructor(aSceneAPI: IScene, aSapiModel: IModel, aDocument: RenderDocument, aGeometryDescriptionUrl: string, aModelDescriptionUrl: string, aTransformation: mat4, aHiddenByDefault: boolean) {
        super(aSceneAPI, aSapiModel, aDocument, aGeometryDescriptionUrl, aModelDescriptionUrl, aTransformation, aHiddenByDefault);
    }

    /**
     * Set transformation for rendering (not doing the baking, the geometry data is in local coordinate all the time)
     * @param aTransformationMatrix
     */
    public setModelTransformation(aTransformationMatrix: mat4) {
        mat4.copy(this.transformation, aTransformationMatrix);

        let geometryObjects = this.geometryDescription.getGeometryObjects();
        for (let geometryObject of geometryObjects) {
            geometryObject.transform(aTransformationMatrix);
        }

        this.document.invalidateBoundingBox();
    }

    public getIsMainModel(): boolean {
        return false;
    }
}
